<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <!-- tab -->
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="filter">
            <!-- <div class="filter-item">
              <p class="label">系统：</p>
              <el-select
                v-model="filter.sys"
                placeholder="全部"
                size="small"
                class="input"
                style="margin: 0 10px"
              >
                <el-option
                  v-for="item in system"
                  :key="item.value"
                  :label="item.labelName"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div> -->

            <div class="filter-item">
              <p class="label">商品品牌：</p>
              <el-select
                v-model="filter.bid"
                placeholder="全部"
                size="small"
                class="input"
                style="margin: 0 10px"
              >
                <el-option
                  v-for="item in brandList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <p class="label">类型：</p>
              <el-select
                v-model="filter.rebateType"
                placeholder="全部"
                size="small"
                class="input"
                style="margin: 0 10px"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>

            <div class="filter-item">
              <div class="label">奖励获得者ID：</div>
              <el-input
                class="input"
                v-model="filter.uid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>

            <div class="filter-item">
              <div class="label">奖励发起者ID：</div>
              <el-input
                class="input"
                v-model="filter.fid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>

            <div class="filter-item">
              <div class="label">关联单号：</div>
              <el-input
                class="input"
                v-model="filter.oid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>

            <div class="filter-item">
              <p class="label">状态：</p>
              <el-select
                v-model="filter.status"
                placeholder="全部"
                size="small"
                class="input"
                style="margin: 0 10px"
              >
                <el-option label="全部" :value="null"> </el-option>
                <el-option label="冻结中" :value="0"> </el-option>
                <el-option label="已解冻" :value="5"> </el-option>
              </el-select>
            </div>

            <div class="filter-item">
              <div class="label">创建时间：</div>
              <el-date-picker
                v-model="date"
                type="datetimerange"
                align="right"
                unlink-panels
                class="date-input"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                size="small"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="btn-box">
            <button class="search" @click="search">筛选</button>
            <button class="reset" @click="reset">重置</button>
            <button
              class="search"
              style="margin-left: 60px"
              @click="order2excel"
            >
              导出
            </button>
          </div>
        </div>
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <!-- <el-table-column
            prop="sys"
            align="center"
            label="系统"
          ></el-table-column> -->
          <el-table-column
            prop="created"
            align="center"
            label="创建时间"
          ></el-table-column>
          <el-table-column
            prop="describe"
            align="center"
            label="商品品牌"
          >
            <div slot-scope="scope">{{ brandMap[scope.row.bid] }}</div>
          </el-table-column>
          <el-table-column
            prop="describe"
            align="center"
            label="奖励类型"
          ></el-table-column>
          <el-table-column
            prop="amount"
            align="center"
            label="奖励金额"
          ></el-table-column>
          <el-table-column
            prop="uid"
            align="center"
            label="奖励获得者ID"
          ></el-table-column>
          <el-table-column
            prop="fid"
            align="center"
            label="奖励发起者ID"
          ></el-table-column>
          <el-table-column prop="status" align="center" label="状态">
            <div slot-scope="scope">
              {{ statusMap[scope.row.status] }}
            </div>
          </el-table-column>
          <el-table-column
            prop="oid"
            align="center"
            label="关联单号"
          ></el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      title="生成中..."
      :visible.sync="showProgressDialog"
      width="30%"
      center
    >
      <el-progress
        :percentage="progress"
        :text-inside="true"
        :stroke-width="18"
      ></el-progress>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import myUtils from '../../components/common/whatever2excel';
import { role, roleMap } from '@/config.js';
export default {
  components: {
    Header
  },
  name: 'balanceRecord',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '资金管理',
        secondTitle: '品牌利润记录'
      },
      filter: {
        // sys: null,
        mode: 'brand',
        rebateType: '',
        uid: null,
        fid: null,
        oid: null,
        status: '',
        bid: null
      },
      role: [
        {
          name: '全部',
          id: -1
        },
        ...role
      ],
      roleMap: roleMap,
      tabActive: 1,
      statusType: [],
      list: [], // 列表
      date: [],
      showProgressDialog: false,
      progress: 0,
      system: [],
      systemMap: {},
      typeList: [],
      typeMap: {},
      brandList: [],
      statusMap: {
        0: '冻结中',
        5: '已解冻'
      },
      brandMap: {}
    };
  },

  mounted() {
    // this.statusType = this.hzType;
    // 获取列表
    this.getList();
    this.getDictionary();
    this.getBrandList();
    this.getFundTypeMap();
  },
  computed: {},
  methods: {
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },

    // 获取列表
    getList() {
      this.filter.begin = this.date[0] || '';
      this.filter.end = this.date[1] || '';
      this.loading++;
      this.httpGet(this.$root.getRebateList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.list = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getFundTypeMap() {
      this.loading++;
      this.httpGet(this.$root.getFundTypeMap, {}).then(
        (res) => {
          this.loading--;
          this.typeMap = res.rebateLog.brand;
          let list = [];
          for(let key in this.typeMap){
            list.push({
              name: this.typeMap[key],
              value: key
            });
          };
          this.typeList = list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 获取轮播列表
    getBrandList() {
      this.loading++;
      this.httpGet(this.$root.getBrandList, {}).then(
        (res) => {
          this.loading--;
          this.brandList = res.list;
          let obj = {};
          res.list.forEach(item => {
            obj[item.id] = item.name;
          });
          this.brandMap = obj;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getDictionary(){
      this.getDictionaryByName('system');
    },
    getDictionaryByName(dataName){
      this.loading++;
      this.httpGet(this.$root.getDictionaryByName, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          this[dataName] = res.list;
          let obj = {};
          res.list.forEach(item => {
            obj[item.value] = item.labelName;
          });
          this[dataName + 'Map'] = obj;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 过滤
    search() {
      this.currentPage = 1;
      this.getList();
    },
    // 重置过滤
    reset() {
      this.filter = {
        bid: null,
        mode: 'brand',
        rebateType: '',
        uid: null,
        fid: null,
        oid: null,
        status: '',
      };
      this.date = [];
      this.getList();
    },
    async order2excel() {
      this.loading++;
      let list = [];
      let totalPage = null;
      let data = {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      };
      await this.httpGet(this.$root.getRebateList, data).then(
        (res) => {
          this.loading--;
          totalPage = Math.ceil(parseInt(res.total) / this.size);
        },
        () => {
          this.loading--;
        }
      );
      this.showProgressDialog = true;
      this.progress = 0;
      await this.getAllPages(totalPage, list).then(
        () => {
          this.showProgressDialog = false;
          this.jsonFormatAndToExcel(list);
        },
        (err) => {
          console.error(err);
          this.showProgressDialog = false;
        }
      );
    },
    async getAllPages(totalPage, list) {
      for (let i = 1; i <= totalPage; i++) {
        let data = {
          page: i,
          size: this.size,
          ...this.filter
        };
        await this.httpGet(this.$root.getRebateList, data).then((res) => {
          list.push(...res.list);
          this.progress = Math.floor((i / totalPage) * 100);
          console.log('page' + i, list.length);
        });
        // console.log(5555, list);
      }
    },
    jsonFormatAndToExcel(list) {
      let formatList = [];
      list.forEach((item) => {
        let obj = {
          创建时间: item.created,
          商品品牌: this.brandMap[item.bid],
          奖励类型: item.describe,
          奖励金额: item.amount,
          奖励获得者ID: item.uid,
          奖励发起者ID: item.fid,
          状态: this.statusMap[item.status],
          关联单号: item.oid
        };
        formatList.push(obj);
      });
      myUtils.json2excel(formatList);
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 10px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin: 16px 0;
      }

      // 表格按钮
      .table-btn {
        // width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
        padding: 0 8px;
      }

      .filter-item {
        margin-right: 12px;
      }

      .select, .input {
        width: 124px;
      }

      .date-input {
        width: 360px;
      }

      .btn-box {
        margin: 0;
      }

      .table {
        margin-top: 24px !important;
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .dialog-content {
    flex-y();
  }

  .form {
    width: 100%;
    flex-center();
    margin: 8px 0;
  }
}

.tabs {
  width: 100%;
  background: #fff;
  height: 60px;
  flex-x(flex-start);
  padding: 0 30px;
  box-sizing: border-box;
  margin-top: 8px;
  flex-shrink: 0;

  .tab {
    background: #fff;
    cursor: pointer;
    padding: 0 15px;
    position: relative;
    width: auto;
    margin-right: 100px;
    height: 100%;
    flex-x(center);
    word(16px, #999);

    &.active {
      word(16px, #333);

      .tab-line {
        width: 100%;
        position: absolute;
        background: #4678E6;
        height: 4px;
        border-radius: 2px;
        left: 0;
        bottom: 3px;
      }
    }
  }
}
</style>
